module.exports = __webpack_public_path__ + "img/Avatar-31.d6a00503.svg";